/* eslint-disable max-len */
/**
 * @file 知识路由
 * @author gaoxunchen
 */

import _ from 'lodash';

import { computeGetUrl, isOa } from '@/utils';
import { REACT_APP_PUBLIC_URL } from '@/constants/Constants';

export default [
  {
    label: '知识',
    key: 'knowledge',
    desc: '全面的知识沉淀，支持知识库查看和营销学堂学习情况分析',
    href: (loginStatus: Record<string, any>) => computeGetUrl(`${REACT_APP_PUBLIC_URL}/knowledge.html#/all`),
    target: '_blank',
    // 新版谷歌浏览器a标签上存在target='_blank'属性时，sessionStorage丢失
    rel: 'opener',
    data: [],
    perm: () => !isOa(),
  },
];
